<template>
    <div class="relative">
        <div v-if="Object.keys(this.progression).length > 0" class="w-full h-full absolute bg-black bg-opacity-70 z-20 flex items-center justify-center">
            <div class="space-y-4">
                <p class="text-3xl font-semibold text-white">{{ $t('etape') }} {{ this.progression.etape }}: {{ this.progression.message }}...</p>
                <div class="w-full flex justify-center">
                    <div class="animate-spin ease-linear rounded-full w-16 h-16 border-t-4 border-b-4 border-orange-500 ml-3">
                    </div>
                </div>
            </div>
        </div>
        <div id="facture" class="w-min h-min relative border-2">
            <div id="btn-print" @click="print" class="h-12 w-12  bg-white cursor-pointer z-10 flex justify-center items-center absolute">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
                </svg>
            </div>
            <div  class=" bg-white w-[95vw] rounded-lg overflow-y-auto max-h-[95vh]  shadow-lg px-2 xl:px-8 py-10 max-w-xl mx-auto">
                <div class="flex items-center justify-between mb-8">
                    <div class="flex items-center">
                        <div class="h-10">
                            <img class="h-full mr-1" src="/logo/mel_logo_all_fond.png" alt="Logo" />
                        </div>
                        <div class="h-auto flex items-center justify-center text-gray-700 font-semibold text-xs md:text-lg">MEL (Marché en ligne)</div>
                    </div>
                    <div class="text-gray-700">
                        <div class="font-bold text-xl mb-2 w-auto text-center">{{ $t('facture') }}</div>
                        <div v-if="langue" class="text-xs md:text-sm">{{ $t('datedecreation') }}: {{ new
                            Date(recu.created_at).toLocaleString(`${langue}`) }} </div>
                        <div class="text-xs md:text-sm w-auto text-center">{{ $t('numero') }} #: {{ recu.matricule }}</div>
                    </div>
                </div>
                <div class="border-b-2 border-gray-300 pb-8 mb-8">
                    <div class="text-gray-700 font-bold mb-2">{{ $t('caissier') }} : <span class=" font-medium">{{ user.name }}</span></div>
                    <div class="text-gray-700 font-bold mb-2">{{ $t('acheteur') }} : <span class=" font-medium">{{ recu.acheteur.name }}</span></div>
                    <div class="text-gray-700 font-bold mb-2">{{ $t('vendeur') }} : <span class=" font-medium">{{ recu.vendeur.name }}</span></div>
                    <div class="text-gray-700 font-bold mb-2">{{$t('ville')}} : <span class=" font-bold">{{ recu.article.ville}}</span>
                    </div>
                    <div class="text-gray-700 font-bold mb-2">{{ $t('pointderelais') }} : <span class=" font-medium">{{recu.relai.numero }}</span></div>
                </div>
                <table class="w-full text-left mb-8">
                    <thead>
                        <tr>
                            <th class="text-gray-700 font-bold uppercase py-2 text-xs md:text-sm">{{ $t('produits') }}</th>
                            <th class="text-gray-700 font-bold uppercase py-2 text-xs md:text-sm">{{ $t('quantites') }}</th>
                            <th class="text-gray-700 font-bold uppercase py-2 text-xs md:text-sm">{{ $t('montantverse') }}</th>
                            <th class="text-gray-700 font-bold uppercase py-2 text-xs md:text-sm">{{ $t('montanttotal') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class=" text-gray-700">{{ recu.article.marque }} {{ recu.article.nom }}</td>
                            <td class=" text-gray-700">
                                <div class="w-full  text-center">{{ recu.quantite }}</div>
                            </td>
                            <td class=" text-gray-700 flex justify-center">
                                <div class="w-full flex justify-center space-x-1">
                                    <div class="h-auto flex items-center ">
                                        <p class=" font-semibold  font-baskerville">{{transformAmount(recu.montant_verse) }}</p>
                                    </div>
                                    <div class="h-auto flex items-center">
                                        <img class="h-5" src="/icons/icon_berry.png" alt="" srcset="">
                                    </div>
                                </div>
                            </td>
                            <td class=" text-gray-700  ">
                                <div class="w-full flex justify-center space-x-1">
                                    <div class="h-auto flex items-center">
                                        <p class=" font-semibold  font-baskerville">{{
                                            transformAmount(recu.montant_total) }}</p>
                                    </div>
                                    <div class="h-auto flex items-center">
                                        <div class="h-auto flex items-center">
                                            <img class="h-5" src="/icons/icon_berry.png" alt="" srcset="">
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="flex justify-end mb-8 space-x-1">
                    <div class="text-gray-700 h-auto flex items-center">{{ $t('total') }}: </div>
                    <div class="text-gray-700 font-bold text-xl">
                        <div class="flex space-x-1">
                            <div class="h-auto flex items-center">
                                <p class=" font-semibold  font-baskerville">{{
                                    transformAmount(recu.montant_total) }}</p>
                            </div>
                            <div class="h-auto flex items-center">
                                <div class="h-auto flex items-center">
                                    <img class="h-5" src="/icons/icon_berry.png" alt="" srcset="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-t-2 border-gray-300 pt-8 mb-8 text-center">
                    <div class="text-gray-700 mb-2">{{ $t('messagecordiale') }}</div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['recuSelect'],
    data(props) {
        return {
            recu: props.recuSelect,
            langue: '',
            user:{},
            progression:{}
        }
    },

    created() {
        window.emitter.on("OpenFacture", (data) => {
            this.progression = data
        })
    },

    mounted() {
        this.user = this.requestAccueil[0]
        this.langue = localStorage.getItem('langue');
    },

    methods: {
        transformAmount(value) {
            var result = ''
            if (value > 0) {
                var text = Math.round(value).toString()
                var countElement = ''
                for (let i = 1; i <= text.length; i++) {
                    result = text[text.length - i] + result
                    countElement += text[text.length - i]
                    if (countElement.length < text.length && countElement.length % 3 == 0) {
                        result = (localStorage.getItem('langue') == 'fr' ? ',' : '.') + result
                    }
                }
            } else {
                result = value
            }

            return result
        },
        async print() {
            this.progression = {
                etape:1,
                message: this.$i18n.messages[`${localStorage.getItem('langue')}`].recuencourdecreation
            }
            var docFac = document.getElementById("facture");
            var btnPrint = document.getElementById("btn-print");
            docFac.removeChild(btnPrint);

            docFac.firstElementChild.classList.replace("max-h-[95vh]","max-h-max")

            // Supprimer contraintes responsive
            docFac.firstElementChild.classList.remove("w-[95vw]");
            docFac.firstElementChild.classList.remove("max-w-xl");
            docFac.firstElementChild.classList.remove("mx-auto");

            // Largeur FIXE pour PDF Letter avec margin:1
            docFac.firstElementChild.style.width = "6in";
            docFac.firstElementChild.style.margin = "0 auto";
            docFac.firstElementChild.style.maxWidth = "none";

            docFac.firstElementChild.classList.remove("overflow-y-auto")
            
            var opt = {
                margin: 1,
                filename: 'myfile.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };

            html2pdf().from(docFac).set(opt).toPdf().output('blob').then((result) => {
                this.progression = {
                    etape:2,
                    message: this.$i18n.messages[`${localStorage.getItem('langue')}`].recuencourdenvoie
                }
                var data = new FormData();
                data.append("file", result);
                data.append("recu", JSON.stringify(this.recu))
                this.axios.post(this.requestHttp + "send-recu", data, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("jwtToken")
                    }
                }).then(() => {
                    window.emitter.emit("alertSucces", ['recu envoyé', this.$i18n.messages[`${localStorage.getItem('langue')}`].recuenvoye])
                    window.emitter.emit("OpenRecu", [{}, false])
                    this.progression = {}
                }).catch(error => {
                    window.emitter.emit("alertError", ['recu non envoyé', this.$i18n.messages[`${localStorage.getItem('langue')}`].recunonenvoye])
                    window.emitter.emit("OpenRecu", [{}, false])
                    this.progression = {}
                })
            })

        }
    },
    computed: {
        requestHttp() {
            return this.$store.state.api
        },
        requestAccueil() {
            return this.$store.state.dataAccueil
        },
    }
}
</script>